'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const Music2Icon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.75 18.75C9.75 20.1307 8.40685 21.25 6.75 21.25C5.09315 21.25 3.75 20.1307 3.75 18.75C3.75 17.3693 5.09315 16.25 6.75 16.25C8.40685 16.25 9.75 17.3693 9.75 18.75ZM9.75 18.75V5.75L20.2522 2.75V15.75M20.2522 15.75C20.2522 17.1307 18.9091 18.25 17.2522 18.25C15.5953 18.25 14.2522 17.1307 14.2522 15.75C14.2522 14.3693 15.5953 13.25 17.2522 13.25C18.9091 13.25 20.2522 14.3693 20.2522 15.75Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpMusic2Icon = forwardRef(Music2Icon);

export { VpMusic2Icon as default };
